module.exports = __webpack_public_path__ + "static/media/merch.7e2cf597.png";